import React from 'react'
import styles from './EdofSection1.module.css'
const EdofSection1 = () => {
    return (
        <div className={styles.mainSection}>
            <div className={styles.ContainerBox}>
                <div className={styles.container}>
                    <div className={styles.LeftSection}>
                        <div className={styles.ImageBox}>
                            <img className={styles.desktopImg} src='/Images/withLogo_lady_full_img3.webp' alt='lady_full_img' loading="lazy" decoding="async" />
                            <img className={styles.mobileImg} src='/Images/with_Logo_Mob_lady_full_img2.webp' alt='lady_mobile_img' loading="lazy" decoding="async" />
                        </div>
                    </div>
                    <div className={styles.RightSection}>
                        <div className={styles.textBox}>
                            <h2>Deseyne Daily Disposable Soft Contact Lens for Presbyopia with Extended Depth of Focus <span className="diffentFamily">(</span>EDOF<span className="diffentFamily">)</span></h2>
                            <h3>The first <span className="diffentFamily">&</span> only Patented EDOF Daily
                                Disposable contact lens for Presbyopia
                                cleared by the FDA.</h3>
                            <p><b>FDA cleared December 2025.</b> This novel contact lens technology introduces a third optical approach to presbyopic correction. At its
                                core is a small on-axis hyper-refractive zone that redirects axial and paraxial light from contributing to retinal image formation. This architecture creates continuous focus from near to distance vision.

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EdofSection1
